import type {} from '@angular/localize/init';
import type { TranslationConfig } from '@bcf-v2/routes-statics/common/app/i18n-cache';
import { appRoutesI18nCache } from '../i18n-cache';

export function preMatchesRouteI18n(config?: TranslationConfig): string {
  if (config?.translateForLang && globalThis.$localizeForLang) {
    return globalThis.$localizeForLang`:url-segment@@pre-matches-url-segment:pre-matches`;
  }
  return (appRoutesI18nCache['pre-matches'] ??= $localize`:url-segment@@pre-matches-url-segment:pre-matches`);
}
